import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { NatureComponent } from './reservations/nature/nature.component';
import { PriorityComponent } from './reservations/priority/priority.component';
import { BackgroundChecksComponent } from "./fleet/background-checks/background-checks.component";
import { PromptComponent } from './prompt/prompt.component';
import { ConfigurationComponent } from './configuration/configuration.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'administration/facilitiesAndAgencies',
        children: [
          { path: 'nature', component: NatureComponent, data: { title: 'Nature'} },
          { path: 'priority', component: PriorityComponent, data: { title: 'Priority'} }
        ]
      },
      { path: 'administration/vehiclesAndDrivers',
        children: [
          { path: 'Background-checks', component: BackgroundChecksComponent, data: { title: 'Background Checks'} }
        ]
      },
      { path: 'administration/system/configuration', component: ConfigurationComponent, data: { title: 'Configuration'} },
      { path: 'administration/epcr',
        children: [
          { path: 'prompt', loadChildren: 'app/pages/administration/prompt/prompt.module#PromptModule', data: { title: 'Prompt'} }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AdministrationRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/administration/administration-routing.module.ts